import { useNavigate, useSearchParams } from 'react-router-dom';
import RegistrationBackground from 'components/RegistrationBackground';
import { FeedbackPanel } from 'components/FeedbackModal';

export default function RegistrationWelcomePage() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const email = searchParams.get('email') || '';
    const countryCode = searchParams.get('countryCode') || '36';
    const serviceProviderNumber = searchParams.get('serviceProviderNumber') || '';
    const phoneNumber = searchParams.get('phoneNumber') || '';
    const requestedJobId = Number(searchParams.get('jobId'));
    const jobId = Number.isSafeInteger(requestedJobId) && requestedJobId > 0
        ? requestedJobId
        : null;
    const formattedPhoneNumber = [`+${countryCode}`, serviceProviderNumber, phoneNumber].filter(Boolean).join(' ');
    const confirmationSearchParams = new URLSearchParams({ email, countryCode, serviceProviderNumber, phoneNumber });
    if (jobId) confirmationSearchParams.set('jobId', String(jobId));

    const actions = (
        <button
            type="button"
            onClick={() => navigate(`/regisztracio-megerosites?${confirmationSearchParams.toString()}`)}
            className="form-action-button form-action-primary flex-1"
        >
            Tovább a megerősítéshez
        </button>
    );

    return (
        <RegistrationBackground>
            <FeedbackPanel
                tone="success"
                title="Köszi, hogy regisztráltál!"
                message={<>A megerősítő kódot erre a telefonszámra küldjük: <strong>{formattedPhoneNumber}</strong></>}
                actions={actions}
            >
                <div className="mt-5 rounded-xl border border-green-100 bg-green-50 p-4 text-sm font-semibold leading-relaxed text-green-900">
                    Legfeljebb 2 percen belül ingyenes SMS-t küldünk a személyre szóló, hatjegyű regisztrációs kódoddal.
                </div>
            </FeedbackPanel>
        </RegistrationBackground>
    );
}
